import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';

const ProfileEditorManager = ({profileContent, setProfileContent, selectedProfile}) => {
  const handleEditorChange = (payload) => {
    if (payload.error) {
      console.error("Error in JSON editor:", payload.error);
      return;
    }

    setProfileContent(prevAllData => ({
      ...prevAllData, 
      
      [selectedProfile]: payload.jsObject 
    }));
  };

  return (
    <div>
      <div style={{ marginTop: '20px' }}>
        <JSONInput
          key={selectedProfile}
          className="w-100"
          height="calc(100vh - 100px)"
          placeholder={profileContent[selectedProfile]}
          onChange={handleEditorChange}
          locale={locale}
        />
      </div>
    </div>
  )
}

export default ProfileEditorManager